import comparisonEstimateStyles from "@shared/comparisonEstimateStyles.cjs";
import { isValidEstimateReplyPrice } from "@/utils/priceFormat";

const { formatComparisonPreferredDesigns, getComparisonPreferredProducts } =
  comparisonEstimateStyles;

export default {
  computed: {
    isReceivingStopped() {
      return Boolean(
        this.isComparisonEstimate && this.estimate.receivingEnabled === false
      );
    },
    hasReplyProducts() {
      return Boolean(
        this.estimate &&
          this.estimate.reply &&
          Array.isArray(this.estimate.reply.products)
      );
    },
    isProductEstimate() {
      return this.estimate && this.estimate.requestType === "product";
    },
    isComparisonEstimate() {
      return this.estimate && this.estimate.requestType === "comparison";
    },
    preferredDesignText() {
      if (!this.estimate || !Array.isArray(this.estimate.preferredDesigns)) {
        return "-";
      }
      return (
        formatComparisonPreferredDesigns(this.estimate.preferredDesigns) || "-"
      );
    },
    preferredProducts() {
      if (!this.estimate || !Array.isArray(this.estimate.preferredDesigns)) {
        return [];
      }
      return getComparisonPreferredProducts(this.estimate.preferredDesigns);
    },
    requestContact() {
      if (!this.estimate) return "-";
      return (
        this.estimate.mobileNo ||
        (this.estimate.user ? this.estimate.user.mobileNo : "") ||
        "-"
      );
    },
    replyImages() {
      if (!this.estimate) return [];
      if (this.estimate.reply && this.estimate.reply.images) {
        return this.estimate.reply.images;
      }
      return [];
    },
    replyImagePrices() {
      if (!this.estimate) return [];
      const reply = this.estimate.reply || {};
      const storedImagePrices = Array.isArray(reply.imagePrices)
        ? reply.imagePrices
        : [];
      return this.replyImages.map((image, index) => {
        const imagePrice = storedImagePrices[index] || {};
        return {
          image,
          price: imagePrice.image === image ? imagePrice.price || "" : "",
        };
      });
    },
    replyPreferredProductPrices() {
      if (!this.estimate) return [];
      const reply = this.estimate.reply || {};
      const storedPrices = Array.isArray(reply.preferredProductPrices)
        ? reply.preferredProductPrices
        : [];
      const pricesByProductId = new Map(
        storedPrices.map((item) => [item && item.productId, item && item.price])
      );
      return this.preferredProducts.map((product) => ({
        ...product,
        price: pricesByProductId.get(product.id) || "",
      }));
    },
    needsPreferredProductPrices() {
      return (
        !this.hasReplyProducts &&
        this.isComparisonEstimate &&
        this.preferredProducts.length > 0 &&
        this.replyPreferredProductPrices.some(
          (product) => !isValidEstimateReplyPrice(product.price)
        )
      );
    },
  },
};
